var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    fillRule: "evenodd",
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5582739,8.97553494 C7.80974924,6.71225688 9.72279394,5 12,5 C14.2772061,5 16.1902508,6.71225688 16.4417261,8.97553494 L17,14 L18.5,14 C19.3284271,14 20,14.6715729 20,15.5 C20,16.3284271 19.3284271,17 18.5,17 L5.5,17 C4.67157288,17 4,16.3284271 4,15.5 C4,14.6715729 4.67157288,14 5.5,14 L7,14 L7.5582739,8.97553494 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 10,
    y: 18,
    rx: 2
  }))));
};
export default SvgNotifications;